/* Maison Ronron v13 bis « ultime » : fiche produit (préfixe f), portée depuis la maquette validée.
   Galerie (ouverture circulaire, anneau glissant, vignettes aimantées, loupe), sélecteur de coloris,
   prix du coloris, vraie photo du coloris choisi (2e case), lueur du bloc d'achat, estimation de livraison. */
(function () {
  'use strict';

  function initFiche(racine) {
    const MR14 = window.MR14;
    const reduit = MR14.reduit;
    const scene = racine.querySelector('[data-f-scene]');
    const calques = [...racine.querySelectorAll('[data-f-calque]')];
    const vigs = [...racine.querySelectorAll('[data-f-vig]')];
    const anneau = racine.querySelector('[data-f-anneau]');
    const num = racine.querySelector('[data-f-num]');
    const calqueColoris = racine.querySelector('[data-f-calque-coloris]');
    const vigColoris = racine.querySelector('[data-f-vig-coloris]');
    const prix = racine.querySelector('[data-f-prix]');
    const lueur = racine.querySelector('[data-f-lueur]');
    const achat = racine.querySelector('[data-f-achat]');
    const pastilles = [...racine.querySelectorAll('[data-f-coloris]')];
    const n = calques.length;
    let photo = 0;
    let prev = 0;
    let anims = null;

    const media = (i) => calques[i] && calques[i].querySelector('.f-media:not([hidden])');
    const souris = (e) => e && e.pointerType === 'mouse';

    // Photo du coloris : on montre l'image du coloris choisi (s'il n'en a pas, la photo affichée reste).
    function majPhotoColoris() {
      [calqueColoris, vigColoris].forEach((boite) => {
        if (!boite) return;
        const imgs = [...boite.querySelectorAll('[data-f-photo]')];
        if (!imgs.some((im) => im.dataset.fPhoto === MR14.coloris)) return;
        imgs.forEach((im) => { im.hidden = im.dataset.fPhoto !== MR14.coloris; });
      });
      if (vigColoris) {
        const im = vigColoris.querySelector('[data-f-photo]:not([hidden])');
        const i = vigs.indexOf(vigColoris);
        if (im && i >= 0) vigColoris.setAttribute('aria-label', 'Photo ' + (i + 1) + ' sur ' + n + ' : ' + (im.dataset.fAlt || im.alt || ''));
      }
    }

    function majCalques() {
      calques.forEach((c, i) => {
        c.classList.toggle('f-calque-haut', i === photo);
        c.classList.toggle('f-calque-bas', i === prev && i !== photo);
        if (i === photo) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
      });
      vigs.forEach((v, i) => {
        v.classList.toggle('f-vignette-on', i === photo);
        v.setAttribute('aria-pressed', i === photo ? 'true' : 'false');
      });
      if (anneau) anneau.className = 'f-anneau f-pos-' + photo;
      if (num) num.textContent = String(photo + 1);
    }

    function annuler() {
      if (anims) { anims.forEach((a) => { try { a.cancel(); } catch (e) { /* rien */ } }); anims = null; }
    }

    function aller(cible, ox, oy) {
      if (!n) return;
      const i = ((cible % n) + n) % n;
      if (i === photo) return;
      annuler();
      prev = photo;
      photo = i;
      majCalques();
      const haut = calques[photo];
      if (reduit || !haut || typeof haut.animate !== 'function') return;
      const pos = ox.toFixed(1) + '% ' + oy.toFixed(1) + '%';
      const liste = [
        haut.animate(
          [{ clipPath: 'circle(0% at ' + pos + ')' }, { clipPath: 'circle(150% at ' + pos + ')' }],
          { duration: 860, easing: 'cubic-bezier(.16,1,.3,1)' }
        ),
      ];
      const hautImg = media(photo);
      if (hautImg) {
        liste.push(hautImg.animate(
          [{ transform: 'scale(1.09)', filter: 'saturate(.8) brightness(1.04)' }, { transform: 'scale(1)', filter: 'saturate(1) brightness(1)' }],
          { duration: 980, easing: 'cubic-bezier(.23,1,.32,1)' }
        ));
      }
      const basImg = media(prev);
      if (basImg) {
        liste.push(basImg.animate(
          [{ transform: 'scale(1)', opacity: 1 }, { transform: 'scale(.96)', opacity: .55 }],
          { duration: 860, easing: 'cubic-bezier(.4,0,1,1)' }
        ));
      }
      anims = liste;
    }

    function depuisVignette(i) {
      let ox = 50;
      const v = vigs[i];
      if (scene && v) {
        const a = scene.getBoundingClientRect();
        const b = v.getBoundingClientRect();
        if (a.width > 0) ox = Math.min(100, Math.max(0, ((b.left + b.width / 2 - a.left) / a.width) * 100));
      }
      aller(i, ox, 100);
    }

    // --- Galerie : flèches, vignettes (aimantation légère), loupe ---
    const precedente = racine.querySelector('[data-f-precedente]');
    const suivante = racine.querySelector('[data-f-suivante]');
    if (precedente) precedente.addEventListener('click', () => aller(photo - 1, 0, 50));
    if (suivante) suivante.addEventListener('click', () => aller(photo + 1, 100, 50));

    vigs.forEach((v, i) => {
      v.addEventListener('click', () => depuisVignette(i));
      v.addEventListener('pointermove', (e) => {
        if (reduit || !souris(e)) return;
        const r = v.getBoundingClientRect();
        if (!r.width) return;
        const dx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width - .5) * 2));
        const dy = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height - .5) * 2));
        v.style.setProperty('--f-tx', (dx * 4).toFixed(2) + 'px');
        v.style.setProperty('--f-ty', (dy * 4).toFixed(2) + 'px');
      });
      v.addEventListener('pointerleave', () => {
        v.style.setProperty('--f-tx', '0px');
        v.style.setProperty('--f-ty', '0px');
      });
    });

    // Balayage au doigt sur la grande photo (téléphone, tablette) : vers la gauche = photo suivante,
    // vers la droite = précédente. Seuls les gestes nettement horizontaux comptent ; le défilement vertical de la page reste libre.
    if (scene && n > 1) {
      let x0 = null;
      let y0 = 0;
      let t0 = 0;
      scene.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
      }, { passive: true });
      scene.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        x0 = null;
        const rapide = Date.now() - t0 < 600;
        if (Math.abs(dx) < (rapide ? 30 : 60) || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        if (dx < 0) aller(photo + 1, 100, 50); else aller(photo - 1, 0, 50);
      }, { passive: true });
      scene.addEventListener('touchcancel', () => { x0 = null; }, { passive: true });
    }

    if (scene) {
      scene.addEventListener('pointermove', (e) => {
        if (reduit || !souris(e)) return;
        const r = scene.getBoundingClientRect();
        if (!r.width) return;
        const x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
        const y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
        scene.style.setProperty('--f-mx', x.toFixed(1) + '%');
        scene.style.setProperty('--f-my', y.toFixed(1) + '%');
      });
    }

    // --- Lueur qui suit le curseur dans le bloc d'achat ---
    if (achat && lueur) {
      achat.addEventListener('pointermove', (e) => {
        if (reduit) return;
        const r = lueur.getBoundingClientRect();
        if (!r.width) return;
        lueur.style.setProperty('--f-gx', (e.clientX - r.left).toFixed(0) + 'px');
        lueur.style.setProperty('--f-gy', (e.clientY - r.top).toFixed(0) + 'px');
      });
    }

    // --- Coloris ---
    function majPastilles() {
      pastilles.forEach((b) => {
        const on = b.dataset.fColoris === MR14.coloris;
        const info = MR14.info(b.dataset.fColoris);
        b.classList.toggle('f-pastille-on', on);
        b.classList.toggle('f-pastille-off', !on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', b.dataset.fNom + (on ? ', coloris sélectionné' : '') + (info && info.dispo ? '' : ', bientôt disponible'));
      });
      const info = MR14.info();
      if (prix && info && info.prix) prix.textContent = MR14.prix(info.prix);
      const illus = calques[0] && calques[0].querySelector('svg[role="img"]');
      if (illus && info) illus.setAttribute('aria-label', 'Illustration du hamac de fenêtre, coloris ' + info.nom);
      if (vigs[0] && info) vigs[0].setAttribute('aria-label', 'Photo 1 sur ' + n + ' : Illustration du hamac de fenêtre, coloris ' + info.nom);
      majPhotoColoris();
    }

    function surColoris() {
      majPastilles();
      const iColoris = calqueColoris ? calques.indexOf(calqueColoris) : -1;
      if (photo !== 0 && photo !== iColoris) { aller(0, 50, 50); return; }
      const img = media(photo);
      if (reduit || !img || typeof img.animate !== 'function') return;
      img.animate(
        [{ opacity: .35, transform: 'scale(.97)', filter: 'blur(6px)' }, { opacity: 1, transform: 'scale(1)', filter: 'blur(0)' }],
        { duration: 700, easing: 'cubic-bezier(.23,1,.32,1)' }
      );
    }

    pastilles.forEach((b) => b.addEventListener('click', () => MR14.choisirColoris(b.dataset.fColoris, b)));
    MR14.surColoris(surColoris);

    // --- Estimation de livraison (5 à 10 jours ouvrés), recalculée à la date du visiteur ---
    const ajoute = (k) => {
      const d = new Date();
      d.setHours(12, 0, 0, 0);
      let c = 0;
      while (c < k) {
        d.setDate(d.getDate() + 1);
        const j = d.getDay();
        if (j !== 0 && j !== 6) c++;
      }
      return d;
    };
    const fmt = (d) => {
      try { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' }); }
      catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
    };
    const debut = racine.querySelector('[data-f-debut]');
    const fin = racine.querySelector('[data-f-fin]');
    if (debut) debut.textContent = fmt(ajoute(5));
    if (fin) fin.textContent = fmt(ajoute(10));

    majCalques();
    majPastilles();
  }

  function demarrer() {
    if (!window.MR14) return;
    window.MR14.pret(() => document.querySelectorAll('[data-f-fiche]').forEach(initFiche));
  }

  // mr14-base.js est chargé avant (defer, dans <head>) ; par prudence, on attend window.MR14.
  if (window.MR14) demarrer();
  else document.addEventListener('DOMContentLoaded', demarrer);
})();
